import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';

export interface UserProfileData {
  msUserAdminID: string;
  adminID: string;
  adminName: string;
  adminEmail: string;
  beelajarEmail: string;
  areaID: string;
  areaName: string | null;
  userIn: string;
  userUp: string;
  dateIn: string;
  dateUp: string;
  isManager: boolean;
}

export interface UserArea {
  areaId: string;
  areaCode: string;
  areaName: string;
}

export interface LoginResponse {
  token: string;
  tokenDurationMinutes: number;
  tokenExpiresAtUtc: string;
  sessionExpiresAtUtc: string;
  user: UserProfileData & {
    listArea: UserArea[];
  };
}

export const loginService = {
  loginWithMicrosoft: async (accessToken: string): Promise<LoginResponse> => {
    const response = await httpClient.get<LoginResponse>(API_ENDPOINTS.MSAL_LOGIN, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        BinusAuthorization: 'Basic ' + process.env.REACT_APP_BASIC_AUTH,
        'X-Skip-Auth-Redirect': 'true'
      }
    });

    return response.data;
  }
};
